module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-bordered table-striped b-t b-light"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), (_vm.isAdministradorExclusivo) ? _c('th', [_vm._v("Registrado em")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Tipo arquivo")]), _vm._v(" "), _c('th', [_vm._v("Preview")]), _vm._v(" "), (_vm.isPermitidoExcluir) ? _c('th', [_vm._v("Apagar?")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredArquivos), function(arquivo, index) {
    return _c('tr', [_c('td', {
      staticClass: "v-middle",
      staticStyle: {
        "max-width": "10%"
      },
      attrs: {
        "scope": "row",
        "width": "10%"
      }
    }, [_vm._v(_vm._s(arquivo.id))]), _vm._v(" "), (_vm.isAdministradorExclusivo) ? _c('td', {
      staticClass: "v-middle",
      staticStyle: {
        "max-width": "10%"
      },
      attrs: {
        "scope": "row",
        "width": "10%"
      }
    }, [_vm._v(_vm._s(_vm._f("formatDate")((arquivo.storageCreatedAt ? arquivo.storageCreatedAt.date : null), 'DD/MM/YYYY HH:mm')))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "v-middle",
      attrs: {
        "scope": "row"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (arquivo.tipo),
        expression: "arquivo.tipo"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(arquivo, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposArquivo), function(tipo) {
      return _c('option', {
        domProps: {
          "value": tipo.id
        }
      }, [_vm._v(_vm._s(tipo.nome))])
    })], 2)]), _vm._v(" "), _c('td', {
      staticStyle: {
        "position": "relative",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center"
      },
      attrs: {
        "scope": "row"
      }
    }, [(!arquivo.id) ? _c('div', {
      staticClass: "img-preview-placeholder"
    }, [_vm._v("\n          Esta imagem é apenas um preview. "), _c('br'), _vm._v(" Salve a GRV para obter o link da imagem original\n        ")]) : _vm._e(), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.acessarLinkPublicoImagemCompleta(arquivo.oldId || arquivo.id)
        }
      }
    }, [(arquivo.tipo !== 3) ? _c('img', {
      ref: ("preview-" + (arquivo.id)),
      refInFor: true,
      staticClass: "img-preview",
      attrs: {
        "src": _vm.geraPreview(arquivo),
        "alt": "foto-veiculo",
        "loading": "lazy"
      }
    }) : _c('span', [_vm._v("Ver assinatura")])])]), _vm._v(" "), (_vm.isPermitidoExcluir && arquivo.tipo !== _vm.TIPO_ARQUIVO_PERICIA) ? _c('td', {
      staticClass: "v-middle",
      attrs: {
        "scope": "row"
      }
    }, [_c('label', {
      staticClass: "i-switch bg-danger m-b-none"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (arquivo.apagar),
        expression: "arquivo.apagar"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'apagar-arquivo' + index,
        "tabindex": "0",
        "aria-checked": "false",
        "aria-invalid": "false"
      },
      domProps: {
        "checked": Array.isArray(arquivo.apagar) ? _vm._i(arquivo.apagar, null) > -1 : (arquivo.apagar)
      },
      on: {
        "change": function($event) {
          var $$a = arquivo.apagar,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(arquivo, "apagar", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(arquivo, "apagar", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(arquivo, "apagar", $$c)
          }
        }
      }
    }), _c('i')])]) : _vm._e()])
  }), _vm._v(" "), (!_vm.arquivos || _vm.arquivos.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Nenhum arquivo nesta GRV")])]) : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-sm m-t-n m-b"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "fileInptImg",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImg",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadDocumento
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "fileInptImgCelular",
    attrs: {
      "type": "file",
      "name": "files[]",
      "id": "fileInptImgCelular",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadDocumentoPeloCelular
    }
  }), _vm._v(" "), (!_vm.isRestritoVisitante) ? _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleInputFile('fileInptImgCelular')
      }
    }
  }, [_vm._v("\n      Adicionar arquivos\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isRestritoVisitante) ? _c('button', {
    staticClass: "btn btn-info btn-md m-l-xs btn-colsultaGrv",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openMultipleInputFile('fileInptImgCelular')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v(" Adicionar imagem pelo celular\n    ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("* Você pode selecionar mais de uma foto ao mesmo tempo para enviar")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c057a40","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv/ArquivosGrv.vue
// module id = 1822
// module chunks = 17